import Vue from 'vue'

const KEY = 'taskblock-profile'

const DEFAULT_HEADER = 'https://image.suisuisu.cn/upload/2607/d1b502465354b537.png'

const DEFAULTS = {
  nickname: '用户',
  email: '',
  avatar: '',
  wallpaper: DEFAULT_HEADER,
  theme: '#5b9147'
}

function readUserSeed() {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return {}
    const user = JSON.parse(raw)
    return {
      nickname: user.nickname || '',
      email: user.email || '',
      avatar: user.avatarUrl || ''
    }
  } catch (e) {
    return {}
  }
}

function loadProfile() {
  const seed = readUserSeed()
  let saved = {}
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) saved = JSON.parse(raw)
  } catch (e) {
    saved = {}
  }
  return {
    nickname: saved.nickname || seed.nickname || DEFAULTS.nickname,
    email: saved.email || seed.email || DEFAULTS.email,
    avatar: saved.avatar || seed.avatar || DEFAULTS.avatar,
    wallpaper: saved.wallpaper || DEFAULTS.wallpaper,
    theme: saved.theme || DEFAULTS.theme,
    passwordHash: saved.passwordHash || '',
    salt: saved.salt || '',
    userWallpapers: Array.isArray(saved.userWallpapers) ? saved.userWallpapers : []
  }
}

export function saveProfile(profile) {
  try {
    localStorage.setItem(KEY, JSON.stringify(profile))
  } catch (e) {
    throw new Error('保存失败，请换一张更小的图片再试')
  }
}

export function syncUserLocalStorage(profile) {
  try {
    const raw = localStorage.getItem('user')
    const user = raw ? JSON.parse(raw) : {}
    user.nickname = profile.nickname || user.nickname || '用户'
    user.email = profile.email || user.email || ''
    user.avatarUrl = profile.avatar || user.avatarUrl || ''
    localStorage.setItem('user', JSON.stringify(user))
  } catch (e) {
    // ignore
  }
}

export function shadeColor(hex, percent) {
  const num = parseInt(hex.replace('#', ''), 16)
  const amt = Math.round(2.55 * percent)
  const R = Math.min(255, Math.max(0, (num >> 16) + amt))
  const G = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amt))
  const B = Math.min(255, Math.max(0, (num & 0x0000ff) + amt))
  return '#' + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)
}

export function hexToRgba(hex, alpha) {
  const num = parseInt(hex.replace('#', ''), 16)
  const r = (num >> 16) & 255
  const g = (num >> 8) & 255
  const b = num & 255
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * 跨组件共享的响应式个人设置（主题色 / 壁纸等）。
 *
 * TaskBlockPage（顶栏背景）、TaskNav（昵称头像）、ProfilePage（设置表单）
 * 都读写同一份设置。用 Vue.observable 让彼此的改动实时互相刷新，
 * 否则各自 loadProfile() 出来的副本互不可见，顶栏背景不会随个人中心的修改而实时变化。
 */
export const profileState = Vue.observable(loadProfile())

// 保证工作副本字段存在（profile 快照里原本没有 phone）
if (profileState.phone === undefined) {
  profileState.phone = ''
}

/**
 * 退出登录 / 改密下线后，把内存中的共享状态重置为默认值，
 * 避免同一会话内重新登录后残留上一个用户的昵称、头像或壁纸。
 */
export function resetProfileState() {
  const fresh = loadProfile()
  Object.keys(profileState).forEach(k => { delete profileState[k] })
  Object.assign(profileState, fresh)
}
